import apiClient from '../apiClient';
import { POST_RESTAURANT_PROFILE_URL } from '../apiUrl';

const postRestaurantProfileApi = data => {
  return apiClient.post(POST_RESTAURANT_PROFILE_URL, data);
};

export default postRestaurantProfileApi;
